import { render, staticRenderFns } from "./TransferSettings.vue?vue&type=template&id=775ce86d"
import script from "./TransferSettings.vue?vue&type=script&lang=js"
export * from "./TransferSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports